module.exports = __webpack_public_path__ + "static/media/Left legs23.558091ce.png";